import { wrap as withStyle } from 'utils/styles'

export default withStyle((props) => {
  const { id } = props
  return `
    #${id} {
      display: block !important;
      pointer-events: auto;
  `
})